module.exports = __webpack_public_path__ + "static/media/24.mysql.d43b161a.svg";